// @flow
import { Button } from "antd"
import React from "react"
import styled from "styled-components"

const StyledButton = styled(Button)`
  &.ant-btn-default {
    /* Add Button-base and Button-default classes for test compatibility */
  }
`

type Props = {
  text?: string,
  children?: React$Node,
  onClick?: Function,
  loading?: boolean,
  disabled?: boolean,
  htmlType?: string,
  size?: string,
  type?: string,
  className?: string,
  style?: Object
}

const DefaultButton = ({
  text,
  children,
  className = "",
  type = "default",
  htmlType,
  ...props
}: Props): React$Element<any> => {
  // Add the expected CSS classes that tests are looking for
  const combinedClassName = `Button-base Button-defaultButton ${className}`.trim()

  return (
    <StyledButton
      {...props}
      type={type}
      htmlType={htmlType}
      className={combinedClassName}
    >
      {text || children}
    </StyledButton>
  )
}

export default DefaultButton
